import type { GameTheme } from "@skillscratch/shared-types";
import background from "./background.webp";
import name from "./name.webp";
import overlay from "./overlay.webp";

export const goldCard = (id: number) => ({
  id: `gold-card-${id}`,
  name: "Gold Card",

  colorScheme: {
    tileColors: [
      { background: "#ffd700", text: "#fff" },
      { background: "#d4af37", text: "#fff" },
      { background: "#b8860b", text: "#fff" },
      { background: "#85754e", text: "#fff" }, 
    ],
    overlayPattern: overlay,
    overlayColor: "#856c1e",
    scratchColor: "#d4af37",

    controlColor: "#d4af37",
    onControlColor: "#fff",
  },

  nameImage: name,
  background: background,
  card: background,
}) satisfies GameTheme;
